import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'irembogov-unpublish-confirmation-modal',
  templateUrl: './unpublish-confirmation-modal.component.html',
  styleUrls: ['./unpublish-confirmation-modal.component.scss'],
})
export class UnpublishConfirmationModalComponent {
  @Input() templateName!: string;
  @Input() show = false;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  onBackdropClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.onCancel();
    }
  }
}
